import 'webp-in-css/polyfill';
import mainMenu from '../../components/header/header.js';
import langSwitcher from '../../components/lang-switcher/lang-switcher';
import { scrollToElement } from '../../scripts/scrollToElement.js';
import { scrollAnimate } from '../../scripts/scrollAnimate.js';
import initForm from '../../components/forms/form.js';
import privacyPolicy from '../../components/privacy-policy/privacy-policy.js';
import ModalForm from '../../components/forms/modal-form.js';
import cookie from '../../components/cookie/cookie.js';
import insertYear from '../../components/footer/footer.js';
import { init as initSentry } from '../../../common/Sentry.js';

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

const disableToScrollAnchors = ['privacy-policy', 'error-modal'];

const anchors = document.querySelectorAll('a[href^="#"]');
for (let anchor of anchors) {
  anchor.addEventListener('click', (e) => {
    const elementId = anchor.getAttribute('href').substr(1);
    if (!disableToScrollAnchors.includes(elementId)) {
      e.preventDefault();
      scrollToElement(anchor.getAttribute('href').substr(1));
    }
  });
}

langSwitcher();
mainMenu();
scrollAnimate().init();
initForm();
privacyPolicy();
ModalForm();
cookie();
insertYear();
initSentry('kz-kz');
